export const thingsToDoArr = [];

export const newVideos = [
  {
    title: "Jérusalem",
    // "sml_desc": "Jérusalem - le coeur du monde",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/heart-of-the-world.jpg",
    img_mob: "/Videos/video_mob/heart-of-the-world.jpg",
    side_img: "Videos/sidebar/heart-of-the-world.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Heart_Of_The_World",
    vidId: "nLKWDp5uA-U",
    ctg: "jerusalem",
    isVid: true,
    forVidPage: true,
    id: "Heart_Of_The_World",
  },
  {
    title: "LA MER MORTE",
    // "sml_desc": "Le plaisir de la vie à son plus haut niveau au point le plus bas sur Terre",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/deadsea2.jpg",
    img_mob: "/PostCarousel/video_mob/100.jpg",
    side_img: "/PostCarousel/DeadSea/deadsea2.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Dead_Sea2",
    isVid: true,
    forVidPage: true,
    vidId: "c93EwT_1EU8",
    ctg: "deadsea",
    id: "Dead_Sea2",
  },

  {
    title: "TEL AVIV, EN BORD DE MER",
    // "sml_desc": "À Tel Aviv, c'est à la plage que bat le cœur de la ville",
    sml_desc: "",
    // "desc": "Préparez-vous à vous éclater comme jamais au soleil",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "jsTzRtTCvWg",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "TelAviv_By_The_Sea",
  },
  {
    title: "Névé Tzedek",
    sml_desc: "",
    // "sml_desc" : "Chic et unique",
    // "desc": "Déborde de cafés pittoresques, boutiques, galeries d'art, élégance et atmosphère rafraîchissante",
    desc: "",
    img: "Videos/j.jpg",
    img_mob: "/Videos/video_mob/j.jpg",
    side_img: "Videos/sidebar/j.jpg",
    read_more: "LIRE LA SuITE",
    vidId: "SUJncZH91Bo",
    link: "/Posts/index.php?postType=video&post=7",
    css_class: "unic_video-post-13",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Neve_Tzedek",
  },

  {
    title: "Sarona Tel Aviv",
    desc: "",
    // "desc": "Un immense choix de lieux à découvrir dans une superbe colonie des Templiers rénovée",
    // "sml_desc": "Une oasis urbaine spectaculaire",
    sml_desc: "",
    img: "Videos/d.jpg",
    img_mob: "/Videos/video_mob/d.jpg",
    side_img: "Videos/sidebar/d.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?postType=video&post=Sarona_TelAviv",
    vidId: "hdquOPEilDo",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Sarona_TelAviv",
  },
  {
    title: "PLAISIRS PORTUAIRES",
    // "sml_desc": "Les ports de Tel Aviv et de Jaffa – différents et fabuleux",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/3.jpg",
    img_mob: "/PostCarousel/video_mob/3.jpg",
    side_img: "/PostCarousel/3.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    forVidPage: true,
    vidId: "a6QMndU0wx0",
    ctg: "telaviv",
    id: "Port_Pleasures",
  },

  {
    title: "La mer Morte ",
    // "sml_desc": "La mer Morte naturel de toute beauté",
    sml_desc: "",
    // "desc": "Le plaisir de la vie à son plus haut  niveau au point le plus bas sur Terre  ",
    desc: "",
    img: "/PostCarousel/DeadSea/natures-glory.jpg",
    img_mob: "/PostCarousel/video_mob/natures-glory.jpg",
    side_img: "/PostCarousel/DeadSea/natures-glory.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Dead_Sea_Video",
    isVid: true,
    forVidPage: true,
    ctg: "deadsea",
    vidId: "ixFocykfYHo",
    id: "Dead_Sea_Video",
  },

  {
    title: "La vieille ville",
    sml_desc: "",
    // "sml_desc": "Sentez l'histoire prendre vie",
    desc: "",
    // "desc": "Laissez-vous inspirer par les trésors de la vieille ville de Jérusalem, connus dans le monde entier",
    img: "Videos/m.jpg",
    img_mob: "/Videos/video_mob/m.jpg",
    side_img: "Videos/sidebar/m.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jerusalem_Old_City",
    isVid: true,
    forVidPage: true,
    vidId: "6eXJu1Yy4kg",
    ctg: "jerusalem",
    id: "Jerusalem_Old_City",
  },

  {
    title: "AVENTURES EN PLEIN AIR",
    // "sml_desc": "Tel Aviv sur roues",
    sml_desc: "",
    // "desc": "Une ville pleine d’action idéale pour les personnes actives",
    desc: "",
    img: "/Videos/12.jpg",
    img_mob: "/Videos/video_mob/12.jpg",
    side_img: "/Videos/12.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Outdoor_Adventures",
    isVid: true,
    forVidPage: true,
    ctg: "telaviv",
    vidId: "88OV6xU0vPI",
    id: "Outdoor_Adventures",
  },

  {
    title: "Moderne et vibrante",
    // "sml_desc": "Tant à voir dans le centre-ville animé de Jérusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    img_mob: "/PostCarousel/video_mob/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Modern_And_Vibrant_Video",
    isVid: true,
    forVidPage: true,
    vidId: "cUBBkziv_4c",
    ctg: "jerusalem",
    id: "Modern_And_Vibrant_Video",
  },

  {
    title: "2 VILLES GRANDIOSES",
    // "sml_desc": "One magical unforgettable getaway to the sun",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    side_img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=42",
    isVid: true,
    forVidPage: true,
    vidId: "b0QexDxEklA",
    ctg: "telavivAndJerusalem",
    id: "2_AWESOME_CITIES",
  },
  {
    title: "JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jerusalem",
    isVid: true,
    forVidPage: true,
    vidId: "k4OwoEk5wMw",
    ctg: "jerusalem",
    id: "Jerusalem",
  },

  {
    title: "Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Tel_Aviv",
    isVid: true,
    forVidPage: true,
    vidId: "I9a4BFWO_6w",
    ctg: "telaviv",
    id: "Tel_Aviv",
  },

  {
    title: "LES JOIES DE LA MER MORTE",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: true,
    forVidPage: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    id: "Natural_Spa",
  },
  {
    title: "Ports de Jaffa",
    // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/TelAviv/jaffa-port.jpg",
    side_img: "/PostCarousel/TelAviv/jaffa-port.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    forVidPage: true,
    vidId: "a6QMndU0wx0",
    ctg: "telaviv",
    id: "Port_Pleasures",
  },

  {
    title: "LES SURPRISES DE JÉRUSALEM",
    // "sml_desc": "A city beyond expectations",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/38.jpg",
    side_img: "/PostCarousel/38.jpg",
    read_more: "LIRE LA SuITE",
    link: this.url + "/Posts/index.php?post=Cool Jerusalem",
    ctg: "jerusalem",
    vidId: "nLKWDp5uA-U",
    isVid: true,
    forVidPage: true,
    id: "Cool_Jerusalem",
  },
  {
    title: "LA MER MORTE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    side_img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Magical_Deadsea",
    vidId: "8p4qfkneH1c",
    isVid: true,
    forVidPage: true,
    ctg: "deadsea",
    id: "Magical_Deadsea",
  },

  {
    title: "LES POINTS FORTS DE TEL AVIV",
    // "sml_desc": "Top 5 things to see and\n do in the city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/17.jpg",
    side_img: "/PostCarousel/17.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=17",
    ctg: "telaviv",
    vidId: "LLOUxE-K_9Y",
    isVid: true,
    forVidPage: true,
    id: "Top_5_Things",
  },

  {
    title: "AVENUE MAMILLA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    vidId: "V0Acsw3Hf_M",
    isVid: true,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Mamilla_Avenue",
  },

  // No translation
  /* Removed from request docsa Google Sheete */
  // {
  //   title: "JOIES DU SHOPPING",
  //   // "sml_desc": "From culture to souvenirs",
  //   sml_desc: "",
  //   desc: "",
  //   img: "/PostCarousel/5.jpg",
  //   side_img: "/PostCarousel/5.jpg",
  //   read_more: "LIRE LA SuITE",
  //   link: "/Posts/index.php?post=Shopping_Delights",
  //   ctg: "jerusalem",
  //   isVid: true,
  //   forVidPage: true,
  //   vidId: "MXtcTm_JXus",
  //   id: "Shopping_Delights",
  // },
  /* ENd Removed from request docsa Google Sheete */

  {
    title: "PARADIS POUR LES GOURMETS",
    // "sml_desc" : "Tel Aviv street food",
    sml_desc: "",
    // "desc" : "A true world-class foodie destination",
    desc: "",
    img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Tel_Aviv_Street_Food",
    isVid: true,
    forVidPage: true,
    vidId: "JQD9JpMaw9g",
    ctg: "telaviv",
    id: "Tel_Aviv_Street_Food",
  },

  {
    title: "Tel Aviv à vélo",
    // "desc": "Get on your bicycle -<br> explore the city in style",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/39.jpg",
    side_img: "PostCarousel/39.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=38",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    vidId: "1Yx2Uht4rms",
    id: 39,
  },
  {
    title: "Jerusalem ‘Musts’",
    // "sml_desc": "5 things to do in the stunning city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: true,
    forVidPage: true,
    vidId: "k4OwoEk5wMw",
    ctg: "jerusalem",
    id: "Jerusalem_Musts",
  },

  {
    title: "Moderne et dynamique",
    // "sml_desc": "Il y a tant à voir dans le centre-ville animé de Jérusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Modern_And_Vibrant_Post",
    isVid: true,
    forVidPage: true,
    vidId: "1Yx2Uht4rms",
    ctg: "jerusalem",
    id: "Modern_And_Vibrant_Post",
  },

  {
    title: "EFFERVESCENCE NON-STOP",
    // "sml_desc": "unforgettable Tel Aviv ",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    side_img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Nonstop_Excitement",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    vidId: "88OV6xU0vPI",
    id: "Nonstop_Excitement",
  },

  // Eilat Posts
 

  {
    title: "EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat1.jpg",
    side_img: "/PostCarousel/eilat1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=EILAT1",
    css_class: "unic-post-EILAT1",
    isVid: true,
    forVidPage: true,
    vidId: "ZdnNT-GDJv4",
    ctg: "eilat-negev",
    id: "EILAT1",
  },
  {
    title: " UN ÉTÉ SANS FIN",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/welcome-to-eilat.jpg",
    side_img: "/PostCarousel/welcome-to-eilat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Welcome_To_Eilat",
    css_class: "unic-post-welcome-to-eilat",
    isVid: true,
    forVidPage: true,
    vidId: "ZdnNT-GDJv4",
    ctg: "eilat-negev",
    id: "Welcome_To_Eilat",
  },

  {
    title: "LE RÉCIF DES DAUPHINS À EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-doolphin-reef.jpg",
    side_img: "/PostCarousel/eilat-doolphin-reef.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Doolphin_Reef",
    css_class: "unic-post-eilat-doolphin-reef",
    isVid: true,
    forVidPage: true,
    vidId: "3Cvz8GoxNzA",
    ctg: "eilat-negev",
    id: "Eilat_Doolphin_Reef",
  },

  {
    title: "FAITES LE GRAND PLONGEON",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    side_img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Ultimate_Beachside",
    css_class: "unic-post-eilat-ultimate-beachside",
    isVid: true,
    forVidPage: true,
    vidId: "ZdnNT-GDJv4",
    ctg: "eilat-negev",
    id: "Eilat_Ultimate_Beachside",
  },

  {
    title: "LE MAJESTUEUX DÉSERT D'ISRAËL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/majestic-desert.jpg",
    side_img: "/PostCarousel/majestic-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Majestic_Desert",
    css_class: "unic-post-majestic-desert",
    isVid: true,
    forVidPage: true,
    vidId: "yXzhH92kREg",
    ctg: "eilat-negev",
    id: "Majestic_Desert",
  },

  {
    title: " LE DÉSERT ISRAÉLIEN",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev.jpg",
    side_img: "/PostCarousel/negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev1",
    css_class: "unic-post-negev",
    isVid: true,
    forVidPage: true,
    vidId: "yXzhH92kREg",
    ctg: "eilat-negev",
    id: "Negev1",
  },
  {
    title: "LE NÉGUEV - COMMENT S’Y RENDRE?",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/location-and-approach.jpg",
    side_img: "/PostCarousel/location-and-approach.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Location_And_Approach",
    css_class: "unic-post-location-and-approach",
    isVid: true,
    forVidPage: true,
    vidId: "5AAqIhkq_tQ",
    ctg: "eilat-negev",
    id: "Location_And_Approach",
  },

  {
    title: "ACTION FUN IN THE ISRAELI DESERT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-fun-in-the-desert.jpg",
    side_img: "/PostCarousel/action-fun-in-the-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Fun_In_The_Desert",
    css_class: "unic-post-action-fun-in-the-desert",
    isVid: true,
    forVidPage: true,
    vidId: "yXzhH92kREg",
    ctg: "eilat-negev",
    id: "Action_Fun_In_The_Desert",
  },
  {
    title: "LA ROUTE DE L'ENCENS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-incense-route.jpg",
    side_img: "/PostCarousel/the-incense-route.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Incense_Route",
    css_class: "unic-post-the-incense-route",
    isVid: true,
    forVidPage: true,
    vidId: "5AAqIhkq_tQ",
    ctg: "eilat-negev",
    id: "The_Incense_Route",
  },

  {
    title: "MASSADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/epic-masada.jpg",
    side_img: "/PostCarousel/epic-masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Epic_Masada",
    css_class: "unic-post-epic-masada",
    isVid: true,
    forVidPage: true,
    vidId: "XxWa_MNm5x8",
    ctg: "eilat-negev",
    id: "Epic_Masada",
  },

  {
    title: "LE PARC DE TIMNA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/timna-treasures.jpg",
    side_img: "/PostCarousel/timna-treasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Timna_Treasures",
    css_class: "unic-post-timna-treasures",
    isVid: true,
    forVidPage: true,
    vidId: "i_4QKtXIeto",
    ctg: "eilat-negev",
    id: "Timna_Treasures",
  },

  {
    title: "DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee1.jpg",
    side_img: "/PostCarousel/galilee1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee_1",
    css_class: "unic-post-galilee1",
    isVid: true,
    forVidPage: true,
    vidId: "5Ep3GgxELag",
    ctg: "north",
    id: "Galilee_1",
  },

  {
    title: "CÉSARÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea_1",
    css_class: "unic-post-caesarea1",
    isVid: true,
    forVidPage: true,
    vidId: "eLZ433_S6HI",
    ctg: "north",
    id: "Caesarea_1",
  },

  {
    title: "LA VIEILLE VILLE D'ACRE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/acre.jpg",
    side_img: "/PostCarousel/acre.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Acre",
    css_class: "unic-post-acre",
    isVid: true,
    forVidPage: true,
    vidId: "KlXXyToCmCM",
    ctg: "north",
    id: "Acre",
  },

  {
    title: "HAÏFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: true,
    forVidPage: true,
    vidId: "3ahATaKkhBk",
    ctg: "north",
    id: "Haifa_1",
  },

  {
    title: "SAFED – OÙ LE MYSTIQUE CÔTOIE LE TERRESTRE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/safed.jpg",
    side_img: "/PostCarousel/safed.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Safed",
    css_class: "unic-post-safed",
    isVid: true,
    forVidPage: true,
    vidId: "i3_ihL51bHo",
    ctg: "north",
    id: "Safed",
  },

  {
    title: "Rosh Pina",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/rosh-pina.jpg",
    side_img: "/PostCarousel/rosh-pina.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Rosh_Pina",
    css_class: "unic-post-rosh-pina",
    isVid: true,
    forVidPage: true,
    vidId: "_qKbHL5-qrQ",
    ctg: "north",
    id: "Rosh_Pina",
  },

  {
    title: "Nazareth",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth.jpg",
    side_img: "/PostCarousel/nazareth.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth",
    isVid: true,
    forVidPage: true,
    vidId: "1M7N5BcmjFM",
    ctg: "north",
    id: "Nazareth",
  },

  {
    title: "CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea_2",
    css_class: "unic-post-caesarea2",
    isVid: true,
    forVidPage: true,
    vidId: "eLZ433_S6HI",
    ctg: "north",
    id: "Caesarea_2",
  },
  {
    title: "BOUGEZ EN GALILÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee-action.jpg",
    side_img: "/PostCarousel/galilee-action.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee_Action",
    css_class: "unic-post-galilee-action",
    isVid: true,
    forVidPage: true,
    vidId: "5Ep3GgxELag",
    ctg: "north",
    id: "Galilee_Action",
  },

  {
    title: "UN JOYAU AUX MULTIPLES FACETTES",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth1.jpg",
    side_img: "/PostCarousel/nazareth1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth1",
    isVid: true,
    forVidPage: true,
    vidId: "1M7N5BcmjFM",
    ctg: "north",
    id: "Nazareth_1",
  },

  {
    title: "LAC DE LA HOULA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/birdtastic-hula-lake.jpg",
    side_img: "/PostCarousel/birdtastic-hula-lake.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Birdtastic_Hula_Lake",
    css_class: "unic-post-birdtastic-hula-lake",
    isVid: true,
    forVidPage: true,
    vidId: "ImobrsxsKl8",
    ctg: "north",
    id: "Birdtastic_Hula_Lake",
  },

  {
    title: "Moderne et vibrante",
    // "sml_desc": "Tant à voir dans le centre-ville animé de Jérusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    img_mob: "/PostCarousel/video_mob/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Modern_And_Vibrant_Video",
    isVid: true,
    forVidPage: true,
    isDouble: true,
    vidId: "cUBBkziv_4c",
    ctg: "jerusalem",
    id: "Modern_And_Vibrant_Video",
  },
];

// start showsArr

// export const showsArr = [

//       {
//         title: "Semaine de la fierté 2020",
//         desc: "",
//         date: "12.06.2020",
//         code_date:"12.06.2020",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Week_2020",
//         css_class: "addopacity  unic-singer-Pride_Parade_2020",
//         id: "Pride_Week_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.2020",
//         code_date:"17.06.2020",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
//         id: "Nickcave_Badseeds",
//         css_class: "addopacity  unic-singer-nickcave-badseeds",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.2020",
//         code_date:"04.08.2020",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "addopacity  unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "addopacity  unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Houtsot Hayotser Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "addopacity  unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Le Festival de la bière de Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "addopacity  unic-singer-jbf_2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Le Festival du vin de Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "addopacity  unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Les Pixies",
//         desc: "",
//         date: "09.2020",
//         code_date:"30.09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "addopacity  unic-singer-pixies-2020",
//         id: "The_Pixies_2020",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Le Festival Maisons Ouvertes",
//         desc: "",
//         date: "09.2020",
//         code_date:"30.09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "addopacity  unic-singer-openhf-2020",
//         id: "Open_Houses_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "La Marche de Jérusalem",
//         desc: "",
//         date: "03.09.2020",
//         code_date:"03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "addopacity  unic-singer-jerusalem-march-2020",
//         id: "The_Jerusalem_March_2020",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.2020",
//         code_date:"04.08.2020",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "addopacity  unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         isDouble: true,
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "addopacity  unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         isDouble: true,
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Houtsot Hayotser Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "addopacity  unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020",
//         isDouble: true,
//         book_now : "LIRE LA SUITE"
//       },

//          //  /*----------------OLD SINGERS------------------*/
//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        code_date:"30.12.2017",
//         img: "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "addopacity  unic-singer-2",
//        id:36,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//       code_date:"26.12.2017",
//         img: "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Lire La suite"
//       },

//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//       code_date:"03.05.2017",
//         img: "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        code_date:"28.06.2017",
//         img: "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//       code_date:"03.07.2017",
//         img: "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//       code_date:"15.07.2017",
//         img: "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//       code_date:"06.12.2017",
//         img: "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//       code_date:"19.11.2017",
//         img: "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Lire La suite"
//       },

//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         code_date: "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Lire La suite"
//       },

//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.08.2017",
//       code_date:"03.08.2017",
//         img: "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "07-23.08.2017",
//       code_date:"23.08.2017",
//         img: "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//       code_date:"19.08.2017",
//         img: "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Lire La suite"
//       },

//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//       code_date:"22.08.2017",
//         img: "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Lire La suite"
//       },

//        {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//       code_date:"10.01.2018",
//         img: "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "addopacity  unic-singer-3",
//        id:29,
//        book_now : "Lire La suite"
//       },

//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         code_date:"09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "addopacity  unic-singer-4",
//         id:17,
//         book_now: "Lire La suite"
//       },

//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.18",
//         code_date:"20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "addopacity  unic-singer-13",
//         id:44,
//         book_now: "Lire La suite"
//       },

//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.18",
//         code_date:"22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "addopacity  unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Lire La suite"
//       },

//       {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         code_date:"14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "addopacity  unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         code_date:"26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-daddyyanke",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         code_date:"03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-tomjones",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         code_date:"11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-paul",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         code_date:"13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-seanpaul",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         code_date:"24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-ozuna",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.19",
//         code_date:"04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "addopacity  unic-singer-68",
//         id:68,
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.19",
//         code_date:"25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-76",
//         id: 76,
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         code_date:"30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-balvin",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//               code_date:"30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "addopacity  unic-singer-69",
//         id:69,
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//               code_date:"01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "addopacity  unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "The International Arts",
//         desc: "",
//         date: "12-24.08.2019",
//               code_date:"24.08.2019",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=94",
//         css_class: "addopacity  unic-singer-inter-arts",
//         id: "The_International_Arts",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "28-29.08.2019",
//               code_date:"29.08.2019",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=91",
//         css_class: "addopacity  unic-singer-jbf",
//         id: "Jerusalem_Beer_Festival",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//               code_date:"12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "addopacity  unic-singer-lionel-richie",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "19-21.09.2019",
//               code_date:"21.09.2019",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=96",
//         css_class: "addopacity  unic-singer-openhf",
//         id: "Open_Houses_Festival",
//         book_now : "LIRE LA SuITE"
//       },

//       // {
//       //   title: "Open Restaurants TLV",
//       //   desc: " Feed Your Curiosity!",
//       //   date: .19",
//       //   img: "Concerts/71.jpg",
//       //   side_img: "Concerts/72.jpg",
//       //   link: this.url + "/Posts/index.php?postType=concerts&post=70",
//       //   css_class: "addopacity  unic-singer-70",
//       //   book_now : "LIRE LA SuITE"
//       // },
//        {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "14.10.2019",
//               code_date:"14.10.2019",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "addopacity  unic-singer-dgt.19",
//         id: "DGTL_Festival",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Cycle Tel Aviv",
//         desc: "",
//         date: "18.10.2019",
//               code_date:"18.10.2019",
//         img: "Concerts/cycle-tlv-2019.jpg",
//         side_img: "Concerts/cycle-tlv-2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "addopacity  unic-singer-cycle-tlv-2019",
//         id: "Cycle_Tel_Aviv",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Night Run Tel Aviv",
//         desc: "",
//         date: "30.10.2019",
//               code_date:"30.10.2019",
//         img: "Concerts/night-run-tlv.jpg",
//         side_img: "Concerts/night-run-tlv.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=98",
//         css_class: "addopacity  unic-singer-tlv-nightru.19",
//         id: "Night_Run_TelAviv",
//         book_now : "LIRE LA SuITE"
//       },

//       {
//         title: "Culinary Festival",
//         desc: "Special Edition: Female Chefs",
//         date: "09-23.11.2019",
//               code_date:"23.11.2019",
//         img: "Concerts/72.jpg",
//         side_img: "Concerts/73.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=71",
//         css_class: "addopacity  unic-singer-71",
//         book_now : "LIRE LA SuITE"
//       },

//      {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.19",
//               code_date:"23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "addopacity  unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Louis CK",
//         desc: "",
//         date: "23.11.19",
//               code_date:"23.11.2019",
//         img: "Concerts/Louis_CK.jpg",
//         side_img: "Concerts/Louis_CK.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Louis_CK",
//         css_class: "addopacity  unic-singer-Louis_CK",
//         id: "Louis_CK",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.19",
//               code_date:"21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "addopacity  unic-singer-jim-jeffries",
//         book_now : "LIRE LA SuITE"
//       },

//       // {
//       //   title: "Open Restaurants TLV",
//       //   desc: " Feed Your Curiosity!",
//       //   date: "2019",
//       //   img:"Concerts/openRestTlv.jpg",
//       //   side_img:"Concerts/openRestTlv.jpg",
//       //   link: "/Posts/index.php?postType=concerts&post=70",
//       //   css_class: "addopacity  unic-singer-70",
//       //   id:70,
//       //   book_now : "LIRE LA SuITE"
//       // },

//       {
//         title: "Le Marathon de Tel-Aviv",
//         desc: "",
//         date: "28.02.2020",
//         code_date:"28.02.2020",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "addopacity  unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Pourim 2020",
//         desc: "",
//         date: "09-10.03.2020",
//         code_date:"10.03.2020",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "addopacity  unic-purim2020",
//         id: "Purim_2020",
//         book_now : "LIRE LA SUITE"
//       },
//         {
//         title: "La Fashion Week de Tel-Aviv",
//         desc: "",
//         date: "03.2020",
//         code_date:"30.03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "addopacity  unic-fashion-week-2020",
//         id: "TelAviv_Fashion_Week_2020",
//         book_now : "LIRE LA SUITE"
//       },

//       {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.2020",
//         code_date:"20.03.2020",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "addopacity  unic-singer-jer-marathon2020",
//         id: "Jerusalem_Marathon",
//         book_now : "LIRE LA SUITE"
//       },

//       // Hadar asked to hide these 3 event till next year - email date 19-05-2020
//       // {
//       //   title: "The Rubinstein International Competition ",
//       //   desc: "",
//       //   date: "05-21.05.2020",
//       //   img:"Concerts/piano-competition-2020.jpg",
//       //   side_img:"Concerts/piano-competition-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition_2020",
//       //   css_class: "addopacity  unic-singer-piano-competition-2020",
//       //   id: "Piano_Competition_2020",
//       //   book_now : "LIRE LA SuITE"
//       // },
//       // {
//       //   title: "Red Hot Chili Peppers",
//       //   desc: "",
//       //   date: "10.06.20",
//       //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers_2020",
//       //   css_class: "addopacity  unic-singer-red-hot-chili-peppers-2020",
//       //   id: "Red_Hot_Chili_Peppers_2020",
//       //   book_now : "LIRE LA SuITE"
//       // },
//       // {
//       //   title: "Nuit Blanche",
//       //   desc: "",
//       //   date: "06.2020",
//       //   code_date:"30.06.2020",
//       //   img:"Concerts/53.jpg",
//       //   side_img:"Concerts/53.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//       //   css_class: "addopacity  unic-singer-white-night-2020",
//       //   id: "White_Night_2020",
//       //   book_now : "LIRE LA SUITE"
//       // },
//        // End Hadar asked to hide these 3 event till next year - email date 19-05-2020

// ];

// End showsArr
export const showsArr = [];

export const faqData = [
  {
    id: 1,
    q: "FOIRE AUX QUESTIONS SUR LE COVID-19",
    answer: `
      <ol start="1">
              <li>
                <strong>Je suis un touriste en Israël et je crains d'avoir le COVID-19, où dois-je aller ?</strong><br/>
                Si vous avez une fièvre d’au moins 38°C ou plus, de la toux, des difficultés respiratoires ou d'autres symptômes respiratoires, vous devez immédiatement vous auto-isoler et appeler le 101 (MDA Emergency Services Hotline) pour un avis médical. Ne vous rendez pas dans une clinique ni dans une salle d'urgence.        
              </li>
              <li>
                <strong>Quand Israël sera-t-il à nouveau ouvert aux visiteurs étrangers ?</strong><br/>
                ’Il est à ce jour possible de se rendre en Israël selon les conditions requises et avec un passeport en règle. Il est demandé à chaque passager de remplir le formulaire d’entrée (voir sur : www.israelsafe.com) et de disposer d’une attestation d’assurance personnelle spécial COVID-19.
              </li>
       
      </ol>
      `,
    isOpen: false,
  },
  {
    id: 2,
    q: "Israël c'est un peu loin, non ?",
    answer: `
      <p>
        Pas autant que vous le pensez : Israël est à seulement 4h15 de vol de Paris et moins de 4h de Marseille. De plus, vous pouvez rejoindre Israël via des douzaines de villes d'Europe.
      </p>
      `,
    isOpen: false,
  },

  {
    id: 3,
    q: "Déplacements",
    answer: `
      
      <h4>BUS:</h4> 
      <p>Israël possède l'un des réseaux de bus les plus performants et économiques au monde puisqu'il relie la plupart des villes, villages et communes diverses.</p>

      <h4>TRAIN:</h4> 
      <p>des trains à grande vitesse relient l'Aéroport Ben Gurion à Tel Aviv, Jérusalem et Haïfa, et des trains rapides et bon marché sillonnent la majeure partie du pays.  Le train est un moyen de transport bon marché et extrêmement simple à utiliser. Cliquez ici pour obtenir des informations complètes.</p>
       
      <h4>AVION:</h4> 
      <p>Arkia, El Al et Israir proposent plusieurs liaisons quotidiennes pour Tel Aviv et Eilat, ainsi que des vols vers Haïfa et la Galilée.</p>
       
      <h4>TAXI:</h4> 
      <p>des taxis sont à votre disposition dans les villes et les chauffeurs vous transporteront avec plaisir d'une ville à l'autre. Consultez le tarif avant de convenir d'un trajet en taxi.</p>
       
      <h4>TAXI COLLECTIF:</h4> 
      <p>les taxis collectifs ou "Sherut" connaissent un vif succès. Des stations "Sherut" sont proposées dans toute la ville. Pour connaître la station la plus proche, adressez-vous à la réception de votre hôtel.</p>
       
      <h4>LOCATION DE VOITURE:</h4> 
      <p>La plupart des sociétés de location internationales possèdent des agences en Israël. Il existe également d'excellentes agences nationales. Votre permis de conduire européen est valable en Israël.</p>
      `,
    isOpen: false,
  },

  {
    id: 4,
    q: "Et pour l'argent?",
    answer: `
      <p>
        La monnaie israélienne est le shekel (officiellement le "nouveau shekel") ; 1 Euro est égal à environ 4 Shekels. Cliquez ici pour connaître le taux de change actuel. Nous vous conseillons, à votre arrivée en Israël, d'utiliser votre carte de crédit pour retirer des devises à l'un des distributeurs automatiques disponibles dans les halls d'arrivée de l'aéroport Ben Gurion, ou de changer de petites sommes ou chèques de voyage à la banque de votre hôtel. Vous trouverez des distributeurs de billets partout en Israël et les cartes de crédit sont largement acceptées.
      </p>
      `,
    isOpen: false,
  },

  {
    id: 5,
    q: "Communications",
    answer: `
        <p>
        La plupart des hôtels proposent généralement une connexion wi-fi gratuite dans le hall, et parfois dans les chambres. De nombreux hôtels possèdent un Centre d'affaires permettant d'accéder gratuitement à Internet et à la messagerie électronique. Les téléphones portables américains qui fonctionnent à l'étranger fonctionneront également en Israël. Le décalage horaire est de + 1 heure: quand il est midi à Paris, il est 13 heures à Jérusalem ou Tel-Aviv.
        </p>
      `,
    isOpen: false,
  },

  {
    id: 6,
    q: "Températures",
    answer: `
      <p>Les températures peuvent être très variables : par conséquent, emportez des vêtements adaptés à la saison et tout ira bien.  La transition entre les saisons n'est bien entendu pas franche, mais les consignes générales sont les suivantes :</p>
 
      <p>ÉTÉ (jun/jul/aou/début sep) :  températures comprises entre 26 et 32ºC.  Tel Aviv et Tibériade ont un climat chaud et humide (similaire à celui de New York ou Miami).  Jérusalem possède un climat plus sec et plus frais, notamment la nuit.  Massada et Eilat enregistrent des températures extrêmement élevées (+ de 43ºC !)... mais l'air y est sec.  Vous n'aurez pas une goutte de pluie.</p>
       
      <p>PRINTEMPS/AUTOMNE (fin mar/avr/mai/fin sep/oct/nov) : températures diurnes très plaisantes dans la plus grande partie du pays (autour de 24°C) mais plus chaudes dans les régions de la mer Rouge et de la mer Morte). À Jérusalem, la température sera d'environ 21°C le jour et 10°C la nuit.  Vous aurez de la pluie, mais peu abondante.</p>
       
      <p>HIVER (déc/jan/fév/début mar) : la météo peut être variable.  Certains hivers sont doux et ensoleillés, d'autres rudes et nuageux. Les pluies fortes sont fréquentes, avec parfois de la neige en janvier et février. La température sera certainement comprise entre 10 et 15°C dans la plupart des régions, mais pourra descendre à 4°C à Jérusalem et en Galilée, voire descendre encore la nuit.</p>
      `,
    isOpen: false,
  },

  {
    id: 7,
    q: "De quels documents ai-je besoin pour venir en Israël ?",
    answer: `
        
        <p>
        Les citoyens français et belges doivent se munir d'un passeport valide au moins six mois après leur date d'arrivée en Israël. Il est inutile de se procurer un visa pour les séjours de moins de trois mois. Les mêmes conditions s'appliquent aux citoyens de la plupart des pays occidentaux. Pour vous en assurer, consultez le document: <a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" target="_blank">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a>
        </p>
      `,
    isOpen: false,
  },
];

export const newPosts = [
  // Videos posts of Section Plan Your trip
  {
    title: "MAH’ANÉ YÉHOUDA",
    // "sml_desc": "Market Madness",
    sml_desc: "",
    // "desc": "Night time celebration in <br>Jerusalem’s Mahane Yehuda",
    desc: "",
    img: "Videos/market-madness.jpg",
    img_mob: "/Videos/video_mob/market-madness.jpg",
    side_img: "Videos/sidebar/market-madness.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Market_Madness",
    vidId: "2CSCe2WC7Ns",
    ctg: "culinary",
    isVid: true,
    forVidPage: true,
    id: "Market_Madness",
  },
  // this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
  // {
  //     "title": "À la recherche d'une vie nocturne de folie ?!",
  //     // "sml_desc": " Book your trip to Tel Aviv!",
  //     "sml_desc": "",
  //     // "desc": "",
  //     "desc": "",
  //     "img": "Videos/crazy-night.jpg",
  //     "img_mob":"/Videos/video_mob/crazy-night.jpg",
  //     "side_img": "Videos/sidebar/crazy-night.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Amazing_Nightlife",
  //     "vidId": "ogEN7aRT0SM",
  //     "ctg": "telaviv",
  //     "isVid": true,
  //     "id": "Amazing_Nightlife"
  // },
  // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked

  {
    title: "Jérusalem",
    // "sml_desc": "Jérusalem - le coeur du monde",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/heart-of-the-world.jpg",
    img_mob: "/Videos/video_mob/heart-of-the-world.jpg",
    side_img: "Videos/sidebar/heart-of-the-world.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Heart_Of_The_World",
    vidId: "nLKWDp5uA-U",
    ctg: "jerusalem",
    isVid: true,
    forVidPage: true,
    id: "Heart_Of_The_World",
  },
  {
    title: "LA MER MORTE",
    // "sml_desc": "Le plaisir de la vie à son plus haut niveau au point le plus bas sur Terre",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/deadsea2.jpg",
    img_mob: "/PostCarousel/video_mob/100.jpg",
    side_img: "/PostCarousel/DeadSea/deadsea2.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Dead_Sea2",
    isVid: true,
    forVidPage: true,
    vidId: "c93EwT_1EU8",
    ctg: "deadsea",
    id: "Dead_Sea2",
  },
  // has ho translation hadar said to hide untill she'll send the translation
  // {
  //     "title": "JAFFA, VILLE MAGIQUE",
  //     "sml_desc": "",
  //     // "sml_desc" : "Explorez tous les trésors de la splendide ville antique de Jaffa",
  //     "desc": "",
  //      // "desc" : "Experience all the riches the beautiful ancient Jaffa has to offer",
  //      "img_mob":"/Videos/video_mob/joys-of-jaffa.jpg",
  //     "img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
  //     "side_img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Joys_Of_Jaffa",
  //     "isVid": true,
  //     "vidId":"a6QMndU0wx0",
  //     "ctg": "telaviv",
  //     "id": "Joys_Of_Jaffa"
  // },
  {
    title: "TEL AVIV, EN BORD DE MER",
    // "sml_desc": "À Tel Aviv, c'est à la plage que bat le cœur de la ville",
    sml_desc: "",
    // "desc": "Préparez-vous à vous éclater comme jamais au soleil",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "jsTzRtTCvWg",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "TelAviv_By_The_Sea",
  },
  {
    title: "Névé Tzedek",
    sml_desc: "",
    // "sml_desc" : "Chic et unique",
    // "desc": "Déborde de cafés pittoresques, boutiques, galeries d'art, élégance et atmosphère rafraîchissante",
    desc: "",
    img: "Videos/j.jpg",
    img_mob: "/Videos/video_mob/j.jpg",
    side_img: "Videos/sidebar/j.jpg",
    read_more: "LIRE LA SuITE",
    vidId: "5jl13Z-38eE",
    link: "/Posts/index.php?postType=video&post=7",
    css_class: "unic_video-post-13",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Neve_Tzedek",
  },

  {
    title: "Sarona Tel Aviv",
    desc: "",
    // "desc": "Un immense choix de lieux à découvrir dans une superbe colonie des Templiers rénovée",
    // "sml_desc": "Une oasis urbaine spectaculaire",
    sml_desc: "",
    img: "Videos/d.jpg",
    img_mob: "/Videos/video_mob/d.jpg",
    side_img: "Videos/sidebar/d.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?postType=video&post=Sarona_TelAviv",
    vidId: "hdquOPEilDo",
    ctg: "telaviv",
    isVid: true,
    forVidPage: true,
    id: "Sarona_TelAviv",
  },
  {
    title: "PLAISIRS PORTUAIRES",
    // "sml_desc": "Les ports de Tel Aviv et de Jaffa – différents et fabuleux",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/3.jpg",
    img_mob: "/PostCarousel/video_mob/3.jpg",
    side_img: "/PostCarousel/3.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    forVidPage: true,
    vidId: "a6QMndU0wx0",
    ctg: "telaviv",
    id: "Port_Pleasures",
  },

  {
    title: "La mer Morte ",
    // "sml_desc": "La mer Morte naturel de toute beauté",
    sml_desc: "",
    // "desc": "Le plaisir de la vie à son plus haut  niveau au point le plus bas sur Terre  ",
    desc: "",
    img: "/PostCarousel/DeadSea/natures-glory.jpg",
    img_mob: "/PostCarousel/video_mob/natures-glory.jpg",
    side_img: "/PostCarousel/DeadSea/natures-glory.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Dead_Sea_Video",
    isVid: true,
    forVidPage: true,
    ctg: "deadsea",
    vidId: "ixFocykfYHo",
    id: "Dead_Sea_Video",
  },

  {
    title: "La vieille ville",
    sml_desc: "",
    // "sml_desc": "Sentez l'histoire prendre vie",
    desc: "",
    // "desc": "Laissez-vous inspirer par les trésors de la vieille ville de Jérusalem, connus dans le monde entier",
    img: "Videos/m.jpg",
    img_mob: "/Videos/video_mob/m.jpg",
    side_img: "Videos/sidebar/m.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jerusalem_Old_City",
    isVid: true,
    forVidPage: true,
    vidId: "6eXJu1Yy4kg",
    ctg: "jerusalem",
    id: "Jerusalem_Old_City",
  },

  {
    title: "AVENTURES EN PLEIN AIR",
    // "sml_desc": "Tel Aviv sur roues",
    sml_desc: "",
    // "desc": "Une ville pleine d’action idéale pour les personnes actives",
    desc: "",
    img: "/Videos/12.jpg",
    img_mob: "/Videos/video_mob/12.jpg",
    side_img: "/Videos/12.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Outdoor_Adventures",
    isVid: true,
    forVidPage: true,
    ctg: "telaviv",
    vidId: "5nqL-oIC0GA",
    id: "Outdoor_Adventures",
  },

  {
    title: "Moderne et vibrante",
    // "sml_desc": "Tant à voir dans le centre-ville animé de Jérusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    img_mob: "/PostCarousel/video_mob/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Modern_And_Vibrant_Video",
    isVid: true,
    forVidPage: true,
    vidId: "cUBBkziv_4c",
    ctg: "jerusalem",
    id: "Modern_And_Vibrant_Video",
  },

  {
    title: "2 VILLES GRANDIOSES",
    // "sml_desc": "One magical unforgettable getaway to the sun",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    side_img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=42",
    isVid: false,
    forVidPage: true,
    ctg: "telavivAndJerusalem",
    id: "2_AWESOME_CITIES",
  },
  {
    title: "JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jerusalem",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem",
  },
  // {
  //     "title": "LE MER MUERTE",
  //     // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/DeadSea/next-level.jpg",
  //     "side_img": "/PostCarousel/DeadSea/next-level.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Next_Level_DS",
  //     "isVid": false,
  //     "ctg": "deadsea",
  //     "id": "Next_Level_DS"
  // },
  {
    title: "Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Tel_Aviv",
    isVid: false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Tel_Aviv",
  },

  // {
  //    "title": "NATURE'S GLORY",
  //     // "sml_desc": "THE DEAD SEA",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
  //     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Natures_Glory",
  //     "isVid": false,
  //     "ctg": "deadsea",
  //     "id": "Natures_Glory"
  // },

  // {
  //     "title": "Go To Guide",
  //     // "sml_desc": "Travel from Tel Aviv and Jerusalem",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/34.jpg",
  //     "side_img": "/PostCarousel/34.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=35",
  //     "ctg": "telaviv",
  //     "isVid": false,
  //     // "id": 35
  //     "id": "Go_To_Guide"
  // },
  // has ho translation' hadar said to hide untill she'll send the translation
  // {
  //     "title": "ALL SENSORY MARKETS",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "thingsToDo/8.jpg",
  //     "side_img": "thingsToDo/sidebar/8.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     "id": "All_Sensory_Markets",
  //     "showOnHome": false,
  //     "ctg": "jerusalem"
  // },

  {
    title: "La cuisine de Jérusalem",
    // "sml_desc": "Appétissante, variée et tellement délicieuse",
    sml_desc: "",
    // "desc": "La cuisine de Jérusalem",
    desc: "",
    img: "PostCarousel/Jerusalem/jerusalem-kitchen.jpg",
    img_mob: "PostCarousel/video_mob/jerusalem-kitchen.jpg",
    side_img: "PostCarousel/Culinary/cuisine-jer.jpg",
    read_more: "LIRE LA SuITE",
    // "link": "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "jsTzRtTCvWg",
    ctg: "culinaryjerusalem",
    isVid: true,
    forVidPage: true,
    id: "Jerusalem_Cuisine",
  },

  {
    title: "Jerusalem ‘Musts’",
    // "sml_desc": "5 things to do in the stunning city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Musts",
  },
  {
    title: "LES JOIES DE LA MER MORTE",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Natural_Spa",
  },
  {
    title: "Ports de Jaffa",
    // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/TelAviv/jaffa-port.jpg",
    side_img: "/PostCarousel/TelAviv/jaffa-port.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Port_Pleasures",
  },
  // {
  //     "title": "Upscale Jerusalem",
  //     // "sml_desc": "Modern luxuries for the pampered traveler",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Jerusalem/45.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/45.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=45",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": 45
  // },
  // {
  //    "title": "NATURAL PHENOMENA",
  //     // "sml_desc": "THE DEAD SEA",
  //      "sml_desc": "",
  //     "desc" : "",
  //     "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
  //     "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Natural_Phenomena",
  //     "isVid": false,
  //     "ctg": "deadsea",
  //     "id": "Natural_Phenomena"
  // },
  {
    // "title": "A Foodie’s Paradise‘",
    title: "Paradis pour les gourmets",
    // "sml_desc": "Explorez l’impressionnante scène culinaire de Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/99.jpg",
    img_mob: "/PostCarousel/video_mob/99.jpg",
    side_img: "/PostCarousel/99.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Simply_Delicious",
    ctg: "culinarytelaviv",
    vidId: "n4kCnPXEX7g",
    isVid: true,
    forVidPage: true,
    id: "Simply_Delicious",
  },
  {
    title: "LES SURPRISES DE JÉRUSALEM",
    // "sml_desc": "A city beyond expectations",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/38.jpg",
    side_img: "/PostCarousel/38.jpg",
    read_more: "LIRE LA SuITE",
    link: this.url + "/Posts/index.php?post=Cool Jerusalem",
    ctg: "jerusalem",
    isVid: false,
    forVidPage: true,
    id: "Cool_Jerusalem",
  },
  {
    title: "LA MER MORTE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    side_img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Magical_Deadsea",
    isVid: false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Magical_Deadsea",
  },

  // has ho translation' hadar said to hide untill she'll send the translation
  // {
  //     "title": "A LA RECHERCHE D'UNE VIE NOCTURNE",
  //     "sml_desc": "",
  //     // "sml_desc": "Amazing Nightlife",
  //     "desc": "",
  //     // "desc": "It’s a never-ending party<br> in the nonstop city!",
  //     "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
  //     "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Amazing_Nightlife",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Amazing_Nightlife"
  // },

  // {
  //    "title": "MASADA",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/DeadSea/masada.jpg",
  //     "side_img": "/PostCarousel/DeadSea/masada.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Masada",
  //     "isVid": false,
  //     "ctg": "deadsea",
  //     "id": "Masada"
  // },
  {
    title: "LES POINTS FORTS DE TEL AVIV",
    // "sml_desc": "Top 5 things to see and\n do in the city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/17.jpg",
    side_img: "/PostCarousel/17.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=17",
    ctg: "telaviv",
    isVid: false,
    forVidPage: true,
    id: "Top_5_Things",
  },
  // {
  //     "title": "First Time in Jerusalem",
  //     // "sml_desc": "The must list for the first time visitor",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "First_Time_In_Jerusalem"
  // },
  // {
  //     "title": "Boutique Hospitality",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
  //     "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Boutique_Hospitality",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Boutique_Hospitality"
  // },
  {
    title: "LES NUITS ANIMÉES DE TEL AVIV",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/ANIMATED_NIGHTS_TEL_AVIV.jpg",
    side_img: "/PostCarousel/TelAviv/ANIMATED_NIGHTS_TEL_AVIV.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=ANIMATED_NIGHTS_TEL_AVIV",
    isVid: false,
    ctg: "telaviv",
    id: "ANIMATED_NIGHTS_TEL_AVIV",
  },
  {
    title: "L’HEURE DE LA SHAKSHUKA",
    // "sml_desc": "Susshuka Zeit",
    sml_desc: "",
    // "desc": "Lerne Sie, wie man das weltberühmte\n Shakshuka-Gericht zubereitet!",
    desc: "",
    img: "/PostCarousel/22.jpg",
    img_mob: "/PostCarousel/video_mob/22.jpg",
    side_img: "/PostCarousel/22.jpg",
    read_more: "Weiterlesen",
    link: "/Posts/index.php?post=22",
    ctg: "culinary",
    vidId: "n4kCnPXEX7g",
    isVid: true,
    forVidPage: true,
    id: "Shakshuka",
  },

  {
    title: "Jerusalem",
    // "sml_desc": "Must eat dishes to try when visiting the magical city",
    desc: "",
    sml_desc: "",
    img: "/PostCarousel/37.jpg",
    img_mob: "/PostCarousel/video_mob/37.jpg",
    side_img: "/PostCarousel/37.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=38",
    ctg: "culinaryjerusalem",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    forVidPage: true,
    id: "A_Taste_Of_Jerusalem",
  },
  {
    title: "PAUSE-CAFÉ À TEL AVIV",
    // "sml_desc": "Tel Aviv over a fresh coffee",
    sml_desc: "",
    // "desc": "Coffee shop culture is fundamental",
    desc: " ",
    img: "Videos/coffee.jpg",
    img_mob: "/Videos/video_mob/coffee.jpg",
    side_img: "Videos/sidebar/coffee.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?postType=video&post=16",
    vidId: "rVr0gqFC364",
    ctg: "culinarytelaviv",
    isVid: true,
    forVidPage: true,
    id: "Coffee_In_TelAviv",
  },
  // {
  //    "title": "SECRETS OF JEWISH JERUSALEM",
  //     "sml_desc" : "",
  //      "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Sectrets_Of_Jewish_Jerusalem"
  // },
  // {
  //     "title": "Non Stop Markets",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
  //     "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Non_Stop_Markets",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Non_Stop_Markets"
  // },
  {
    title: "AVENUE MAMILLA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Mamilla_Avenue",
  },

  // {
  //     "title": "TOWER OF DAVID MUSEUM",
  //     "sml_desc": "",
  //     "img": "thingsToDo/7.jpg",
  //     "side_img": "thingsToDo/sidebar/7.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     "id": "Tower_Of_David_Museum",
  //     "showOnHome": false,
  //     "ctg": "jerusalem"

  // },

  // {
  //    "title": "JERUSALEM’S ART",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Jerusalem_Arts",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem_Arts"
  // },

  // {
  //    "title": "MUST EAT IN JERUSALEM",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Must_Eat_In_Jerusalem"
  // },
  {
    title: "MANGER VEGAN A TEL-AVIV",
    // "sml_desc": "1ère destination mondiale pour les vegans",
    // "desc": "Dégustez un large choix de délices vegans, même des glaces !",
    sml_desc: "",
    desc: "",
    img: "Videos/h.jpg",
    img_mob: "/Videos/video_mob/h.jpg",
    side_img: "Videos/sidebar/h.jpg",
    vidId: "S2NGYP3QQT8",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=6",
    ctg: "culinarytelaviv",
    isVid: true,
    forVidPage: true,
    id: "Vegan_Friendly_TelAviv",
  },

  {
    title: "BONS PLANS SUR TEL AVIV",
    // "sml_desc": "Cool things to do in the hot city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/40.jpg",
    side_img: "/PostCarousel/40.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=TelAviv_Adventures",
    ctg: "telaviv",
    isVid: false,
    id: "TelAviv_Adventures",
  },
  // {
  //     "title": "UNFORGETTABLE YAD VASHEM",
  //     "sml_desc": "",
  //     "img": "thingsToDo/10.jpg",
  //     "side_img": "thingsToDo/sidebar/10.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     id: 31,
  //     "showOnHome": false,
  //     "ctg": "jerusalem"

  // },

  // {
  //    "title": "THE GATES OF JERUSALEM",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/gates.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/gates.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "The_Gates_Of_Jerusalem"
  // },
  {
    title: "Une journée à Tel Aviv",
    sml_desc: "",
    // "sml_desc" : "Day isTrippin’",
    desc: "",
    // "desc" : "Fabulous and fascinating one day in Tel Aviv",
    img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    side_img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Day_IsTrippin",
    isVid: false,
    ctg: "telaviv",
    id: "Day_IsTrippin",
  },
  // {
  //     "title": "JERUSALEM MAIN SITES",
  //     // "sml_desc": "Travel back thousands of years",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=9",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": 99
  // },
  {
    title: "SCÈNE GOURMANDE SUR TEL-AVIV",
    // "sml_desc": "The perfect place\n to treat yourself",
    sml_desc: "",
    // "desc": "Tel Aviv's huge variety of amazing",
    desc: "",
    img: "Videos/e.jpg",
    img_mob: "/Videos/video_mob/e.jpg",
    side_img: "Videos/sidebar/e.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?postType=video&post=33",
    vidId: "jfyHxk8ZRrI",
    ctg: "culinarytelaviv",
    isVid: true,
    forVidPage: true,
    id: "Gourmet_TelAviv",
  },
  // {
  //     "title": "WESTERN WALL WONDERS",
  //     "sml_desc": "",
  //     "img": "thingsToDo/4.jpg",
  //     "side_img": "thingsToDo/sidebar/4.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Western_Wall_Wonders",
  //     "css_class": "unic_video-post-Western_Wall_Wonders",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     "id": "Western_Wall_Wonders",
  //     "ctg": "jerusalem",
  //     "showOnHome": false,

  // },
  // has ho translation' hadar said to hide untill she'll send the translation
  // {
  //     "title": "TRAVELLING ON A BUDGET",
  //     // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/44.jpg",
  //     "side_img": "/PostCarousel/44.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=44",
  //     "isVid": false,
  //     "ctg": "telavivAndJerusalem",
  //     "id": 44
  // },
  {
    title: "DES ACHATS UNIQUES À ISRAËL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/unique.jpg",
    side_img: "/PostCarousel/Jerusalem/unique.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Purchases_In_Israel",
    isVid: false,
    ctg: "jerusalem",
    id: "Purchases_In_Israel",
  },
  {
    title: "PARADIS POUR LES GOURMETS",
    // "sml_desc" : "Tel Aviv street food",
    sml_desc: "",
    // "desc" : "A true world-class foodie destination",
    desc: "",
    img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Tel_Aviv_Street_Food",
    isVid: false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Tel_Aviv_Street_Food",
  },
  // {
  //    "title": "JERUSALEM FUN",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Jerusalem_Fun",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem_Fun"
  // },
  {
    title: "Tel Aviv à vélo",
    // "desc": "Get on your bicycle -<br> explore the city in style",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/39.jpg",
    side_img: "PostCarousel/39.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=38",
    ctg: "telaviv",
    isVid: false,
    forVidPage: true,
    id: 39,
  },

  // {
  //     "title": "ULTIMATE BEACH FUN",
  //     "sml_desc": "",
  //     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
  //     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
  //     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=24",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": true,
  //     "id":"Ultimate_Beach_Fun",
  //     "ctg": "telaviv",
  //     "showOnHome": false,

  // },

  {
    title: "Moderne et dynamique",
    // "sml_desc": "Il y a tant à voir dans le centre-ville animé de Jérusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Modern_And_Vibrant_Post",
    isVid: false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Modern_And_Vibrant_Post",
  },
  // {
  //     "title": "WHITE CITY SPLENDOR",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "thingsToDo/6.jpg",
  //     "side_img": "thingsToDo/sidebar/6.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": false,
  //     id: 28,
  //     "showOnHome": false,
  //     "ctg": "telaviv"

  // },
  // {
  //    "title": "Jerusalem after dark fun",
  //     "sml_desc" : "",
  //     "desc" : "",
  //     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
  //     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
  //     "isVid": false,
  //     "ctg": "jerusalem",
  //     "id": "Jerusalem_After_Dark_Fun"
  // },
  {
    title: "TEL AVIV",
    // "sml_desc": "Enjoy and Indulge",
    sml_desc: "",
    // "desc": "Tel Aviv - The ultimate luxury destination",
    desc: "",
    img: "/PostCarousel/36.jpg",
    side_img: "/PostCarousel/36.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=37",
    ctg: "telaviv",
    isVid: false,
    id: 37,
  },

  // has ho translation' hadar said to hide untill she'll send the translation
  // {
  //    "title" : "À L’HEURE DE LA CULTURE",
  //     // "sml_desc": "Non Stop Culture",
  //     "sml_desc" : "",
  //     // "desc": "Tel Aviv’s fascinating cultural scene",
  //      "desc" : "",
  //     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=Non_Stop_Culture",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Non_Stop_Culture"
  // },
  // end has ho translation' hadar said to hide untill she'll send the translation

  {
    title: "Jamie Oliver à Tel Aviv",
    // "sml_desc": "Jamie Oliver découvre les saveurs des petits-déjeuners de Tel Aviv ",
    sml_desc: "",
    desc: "",
    img: "Videos/jamie-oliver.jpg",
    img_mob: "/Videos/video_mob/jamie-oliver.jpg",
    side_img: "Videos/sidebar/jamie-oliver.jpg",
    vidId: "gGe4W8WaIiQ",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jamie_Oliver",
    ctg: "culinarytelaviv",
    isVid: true,
    forVidPage: true,
    id: "Jamie_Oliver",
  },

  // No translation
  /* Removed from request docsa Google Sheete */
  // {
  //   title: "JOIES DU SHOPPING",
  //   // "sml_desc": "From culture to souvenirs",
  //   sml_desc: "",
  //   desc: "",
  //   img: "/PostCarousel/5.jpg",
  //   side_img: "/PostCarousel/5.jpg",
  //   read_more: "LIRE LA SuITE",
  //   link: "/Posts/index.php?post=Shopping_Delights",
  //   ctg: "jerusalem",
  //   isVid: false,
  //   forVidPage: true,
  //   id: "Shopping_Delights",
  // },
  /* End Removed from request docsa Google Sheete */
  // End No translation

  // {
  //     "title": "Party Capital",
  //     // "sml_desc": "Epic Nights in the non stop city",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/42.jpg",
  //     "side_img": "/PostCarousel/42.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=42",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     "id": "Party_Capital"
  // },
  // has ho translation' hadar said to hide untill she'll send the translation
  // {
  //     "title": "PLAGES SENSATIONNELLES",
  //     // "sml_desc": "Come chill by the sunny beaches",
  //     "sml_desc": "",
  //     "desc": "",
  //     "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
  //     "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
  //     "read_more": "LIRE LA SuITE",
  //     "link": "/Posts/index.php?post=14",
  //     "isVid": false,
  //     "ctg": "telaviv",
  //     //"id": 14
  //     "id":"Sensational_Beaches"
  // },
  {
    title: "EFFERVESCENCE NON-STOP",
    // "sml_desc": "unforgettable Tel Aviv ",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    side_img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Nonstop_Excitement",
    ctg: "telaviv",
    isVid: false,
    forVidPage: true,
    id: "Nonstop_Excitement",
  },

  // Eilat Posts
  {
    title: "Neot Semadar",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/Neot_Semadar.jpg",
    side_img: "PostCarousel/Neot_Semadar.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Neot_Semadar",
    css_class: "unic-post-Neot-Semadar",
    isVid: false,
    // vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Neot_Semadar",
  },
  {
    title: "EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat1.jpg",
    side_img: "/PostCarousel/eilat1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=EILAT1",
    css_class: "unic-post-EILAT1",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "EILAT1",
  },
  {
    title: " UN ÉTÉ SANS FIN",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/welcome-to-eilat.jpg",
    side_img: "/PostCarousel/welcome-to-eilat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Welcome_To_Eilat",
    css_class: "unic-post-welcome-to-eilat",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Welcome_To_Eilat",
  },

  {
    title: "la destination de vacances idéale",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-ultimate-holiday.jpg",
    side_img: "/PostCarousel/the-ultimate-holiday.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Ultimate_Holiday",
    css_class: "unic-post-the-ultimate-holiday",
    isVid: false,
    ctg: "eilat-negev",
    id: "The_Ultimate_Holiday",
  },
  // {
  //  "title":"EILAT’S CALLING",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/eilat-calling.jpg",
  //  "side_img":"/PostCarousel/eilat-calling.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Eilat_Calling",
  //  "css_class":"unic-post-eilat-calling",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Eilat_Calling'
  // },
  {
    title: "LE RÉCIF DES DAUPHINS À EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-doolphin-reef.jpg",
    side_img: "/PostCarousel/eilat-doolphin-reef.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Doolphin_Reef",
    css_class: "unic-post-eilat-doolphin-reef",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Doolphin_Reef",
  },
  // {
  //  "title":"Action Packed Eilat",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/action-packed-eilat.jpg",
  //  "side_img":"/PostCarousel/action-packed-eilat.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Action_Packed_Eilat",
  //  "css_class":"unic-post-action-packed-eilat",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Action_Packed_Eilat'
  // },
  {
    title: "FAITES LE GRAND PLONGEON",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    side_img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Ultimate_Beachside",
    css_class: "unic-post-eilat-ultimate-beachside",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Ultimate_Beachside",
  },
  // {
  //  "title":"One Day in Eilat",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/one-day-in-eilat.jpg",
  //  "side_img":"/PostCarousel/one-day-in-eilat.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=One_Day_In_Eilat",
  //  "css_class":"unic-post-one-day-in-eilat",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'One_Day_In_Eilat'
  // },
  {
    title: "LE MAJESTUEUX DÉSERT D'ISRAËL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/majestic-desert.jpg",
    side_img: "/PostCarousel/majestic-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Majestic_Desert",
    css_class: "unic-post-majestic-desert",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Majestic_Desert",
  },
  {
    title: "ARAVA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/ha-arava.jpg",
    side_img: "/PostCarousel/ha-arava.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Ha_Arava",
    css_class: "unic-post-ha-arava",
    isVid: false,
    ctg: "eilat-negev",
    id: "Ha_Arava",
  },
  {
    title: " LE DÉSERT ISRAÉLIEN",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev.jpg",
    side_img: "/PostCarousel/negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev1",
    css_class: "unic-post-negev",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Negev1",
  },
  {
    title: "LE NÉGUEV - COMMENT S’Y RENDRE?",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/location-and-approach.jpg",
    side_img: "/PostCarousel/location-and-approach.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Location_And_Approach",
    css_class: "unic-post-location-and-approach",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Location_And_Approach",
  },
  {
    title: "UN SÉJOUR DANS LE NÉGUEV",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/stay-in-the-negev.jpg",
    side_img: "/PostCarousel/stay-in-the-negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Stay_In_The_Negev",
    css_class: "unic-post-stay-in-the-negev",
    isVid: false,
    ctg: "eilat-negev",
    id: "Stay_In_The_Negev",
  },
  {
    title: "TOUT SIMPLEMENT MAGIQUE!",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/pure-desert-magic.jpg",
    side_img: "/PostCarousel/pure-desert-magic.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Pure_Desert_Magic",
    css_class: "unic-post-pure-desert-magic",
    isVid: false,
    ctg: "eilat-negev",
    id: "Pure_Desert_Magic",
  },
  {
    title: "ACTION FUN IN THE ISRAELI DESERT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-fun-in-the-desert.jpg",
    side_img: "/PostCarousel/action-fun-in-the-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Fun_In_The_Desert",
    css_class: "unic-post-action-fun-in-the-desert",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Action_Fun_In_The_Desert",
  },
  {
    title: "LA ROUTE DE L'ENCENS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-incense-route.jpg",
    side_img: "/PostCarousel/the-incense-route.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Incense_Route",
    css_class: "unic-post-the-incense-route",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "The_Incense_Route",
  },
  // {
  //  "title":"Mount Karkom",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/mount-karkom.jpg",
  //  "side_img":"/PostCarousel/mount-karkom.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Mount_Karkom",
  //  "css_class":"unic-post-mount-karkom",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Mount_Karkom'
  // },
  // {
  //  "title":"Machtesh Ramon",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/machtes-ramon.jpg",
  //  "side_img":"/PostCarousel/machtes-ramon.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Machtesh_Ramon",
  //  "css_class":"unic-post-machtes-ramon",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Machtesh_Ramon'
  // },
  {
    title: "MASSADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/epic-masada.jpg",
    side_img: "/PostCarousel/epic-masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Epic_Masada",
    css_class: "unic-post-epic-masada",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Epic_Masada",
  },
  // {
  //  "title":"The Bedouin Experience",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/the-bedouin-experience.jpg",
  //  "side_img":"/PostCarousel/the-bedouin-experience.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Bedouin_Experience",
  //  "css_class":"unic-post-the-bedouin-experience",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'The_Bedouin_Experience'
  // },
  // {
  //  "title":"The Israel National Trail",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/the-israel-national-trail.jpg",
  //  "side_img":"/PostCarousel/the-israel-national-trail.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Israel_National_Trail",
  //  "css_class":"unic-post-the-israel-national-trail",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'The_Israel_National_Trail'
  // },
  {
    title: "LE PARC DE TIMNA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/timna-treasures.jpg",
    side_img: "/PostCarousel/timna-treasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Timna_Treasures",
    css_class: "unic-post-timna-treasures",
    isVid: false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Timna_Treasures",
  },
  {
    title: "DÉSERT DU NÉGUEV – À NE PAS MANQUER",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev-desert-dont-miss.jpg",
    side_img: "/PostCarousel/negev-desert-dont-miss.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev_Desert_Dont_Miss",
    css_class: "unic-post-negev-desert-dont-miss",
    isVid: false,
    ctg: "eilat-negev",
    id: "Negev_Desert_Dont_Miss",
  },
  // {
  //  "title":"NEGEV CHARMS",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/negev-charms.jpg",
  //  "side_img":"/PostCarousel/negev-charms.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Negev_Charms",
  //  "css_class":"unic-post-negev-charms",
  //  "isVid" : false,
  //  "ctg"   : 'eilat-negev',
  //   "id"    : 'Negev_Charms'
  // },
  // End Eilat Posts

  // North Posts
  // {
  //  "title":"Galilee",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/galilee.jpg",
  //  "side_img":"/PostCarousel/galilee.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Galilee",
  //  "css_class":"unic-post-galilee",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Galilee'
  // },

  {
    title: "DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee1.jpg",
    side_img: "/PostCarousel/galilee1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee_1",
    css_class: "unic-post-galilee1",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Galilee_1",
  },
  // {
  //  "title":"Caesarea",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/caesarea.jpg",
  //  "side_img":"/PostCarousel/caesarea.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Caesarea",
  //  "css_class":"unic-post-caesarea",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Caesarea'
  // },

  {
    title: "CÉSARÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea_1",
    css_class: "unic-post-caesarea1",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Caesarea_1",
  },

  {
    title: "LA VIEILLE VILLE D'ACRE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/acre.jpg",
    side_img: "/PostCarousel/acre.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Acre",
    css_class: "unic-post-acre",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Acre",
  },
  // {
  //  "title":"Haifa",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/haifa.jpg",
  //  "side_img":"/PostCarousel/haifa.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Haifa",
  //  "css_class":"unic-post-haifa",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Haifa'
  // },
  {
    title: "HAÏFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Haifa_1",
  },

  {
    title: "SAFED – OÙ LE MYSTIQUE CÔTOIE LE TERRESTRE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/safed.jpg",
    side_img: "/PostCarousel/safed.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Safed",
    css_class: "unic-post-safed",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Safed",
  },
  // {
  //  "title":"THE STUNNING BAHA’I GARDENS",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/bahai-gardens.jpg",
  //  "side_img":"/PostCarousel/bahai-gardens.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Bahai_Gardens",
  //  "css_class":"unic-post-bahai-gardens",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'The_Bahai_Gardens'
  // },
  // {
  //  "title":"The Sea of Galilee (Kinneret )",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/sea-of-galilee.jpg",
  //  "side_img":"/PostCarousel/sea-of-galilee.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Sea_Of_Galilee",
  //  "css_class":"unic-post-sea-of-galilee",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'The_Sea_Of_Galilee'
  // },
  {
    title: "Rosh Pina",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/rosh-pina.jpg",
    side_img: "/PostCarousel/rosh-pina.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Rosh_Pina",
    css_class: "unic-post-rosh-pina",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Rosh_Pina",
  },

  // {
  //  "title":"Cheers to Israel",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/cheers-to-israel.jpg",
  //  "side_img":"/PostCarousel/cheers-to-israel.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Cheers_To_Israel",
  //  "css_class":"unic-post-cheers-to-israel",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Cheers_To_Israel'
  // },

  {
    title: "DES VACANCES GASTRONOMIQUES EN GALILÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilean-treat.jpg",
    side_img: "/PostCarousel/galilean-treat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=A_Galilean_Treat",
    css_class: "unic-post-galilean-treat",
    isVid: false,
    forVidPage: true,
    ctg: "culinarynorth",
    id: "A_Galilean_Treat",
  },
  {
    title: "Nazareth",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth.jpg",
    side_img: "/PostCarousel/nazareth.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Nazareth",
  },

  {
    title: "CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea_2",
    css_class: "unic-post-caesarea2",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Caesarea_2",
  },
  {
    title: "BOUGEZ EN GALILÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee-action.jpg",
    side_img: "/PostCarousel/galilee-action.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee_Action",
    css_class: "unic-post-galilee-action",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Galilee_Action",
  },
  // {
  //  "title":"Bet She’an",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/bet-shean.jpg",
  //  "side_img":"/PostCarousel/bet-shean.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Bet_Shean",
  //  "css_class":"unic-post-bet-shean",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Bet_Shean'
  // },

  // {
  //  "title":"Zichron Ya’akov",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/zichron-yaakov.jpg",
  //  "side_img":"/PostCarousel/zichron-yaakov.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Zichron_Yaakov",
  //  "css_class":"unic-post-zichron-yaakov",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Zichron_Yaakov'
  // },

  {
    title: "LA BEAUTÉ SOURCE D'INSPIRATION",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa-beauty.jpg",
    side_img: "/PostCarousel/haifa-beauty.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa_Beauty",
    css_class: "unic-post-Haifa_Beauty",
    isVid: false,
    ctg: "north",
    id: "Haifa_Beauty",
  },
  // {
  //  "title":"Discover the Wine Routes",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/discover-the-wine-routes.jpg",
  //  "side_img":"/PostCarousel/discover-the-wine-routes.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Discover_The_Wine_Routes",
  //  "css_class":"unic-post-discover-the-wine-routes",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Discover_The_Wine_Routes'
  // },
  {
    title: "UN JOYAU AUX MULTIPLES FACETTES",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth1.jpg",
    side_img: "/PostCarousel/nazareth1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth1",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Nazareth_1",
  },

  {
    title: "LAC DE LA HOULA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/birdtastic-hula-lake.jpg",
    side_img: "/PostCarousel/birdtastic-hula-lake.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Birdtastic_Hula_Lake",
    css_class: "unic-post-birdtastic-hula-lake",
    isVid: false,
    forVidPage: true,
    ctg: "north",
    id: "Birdtastic_Hula_Lake",
  },

  // not translated
  // {
  //  "title":"L'EXPÉRIENCE INCOMPARABLE DU KIBBOUTZ",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/kibbutz-experience.jpg",
  //  "side_img":"/PostCarousel/kibbutz-experience.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=The_Kibbutz_Experience",
  //  "css_class":"unic-post-kibbutz-experience",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'The_Kibbutz_Experience'
  // },
  // {
  //  "title":"NATIONAL PARKS",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/national-parks.jpg",
  //  "side_img":"/PostCarousel/national-parks.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=National_Parks",
  //  "css_class":"unic-post-national-parks",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'National_Parks'
  // },

  // {
  //  "title":"Tiberias (Tverya)",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/tiberias.jpg",
  //  "side_img":"/PostCarousel/tiberias.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=Tiberias",
  //  "css_class":"unic-post-tiberias",
  //  "isVid" : false,
  //  "ctg"   : 'north',
  //   "id"    : 'Tiberias'
  // },

  // These 2 posts doubled for complite the Jerusalem Carousel
  {
    title: "La vieille ville",
    sml_desc: "",
    // "sml_desc": "Sentez l'histoire prendre vie",
    desc: "",
    // "desc": "Laissez-vous inspirer par les trésors de la vieille ville de Jérusalem, connus dans le monde entier",
    img: "Videos/m.jpg",
    img_mob: "/Videos/video_mob/m.jpg",
    side_img: "Videos/sidebar/m.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Jerusalem_Old_City",
    isVid: true,
    isDouble: true,
    vidId: "6eXJu1Yy4kg",
    ctg: "jerusalem",
    id: "Jerusalem_Old_City",
  },
  {
    title: "AVENUE MAMILLA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    isVid: false,
    forVidPage: true,
    isDouble: true,
    ctg: "jerusalem",
    id: "Mamilla_Avenue",
  },
  // End These 2 posts doubled for complite the Jerusalem Carousel

  // This post doubled for complite the TEL AVIV Carousel
  {
    title: "Une journée à Tel Aviv",
    sml_desc: "",
    // "sml_desc" : "Day isTrippin’",
    desc: "",
    // "desc" : "Fabulous and fascinating one day in Tel Aviv",
    img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    side_img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Day_IsTrippin",
    isVid: false,
    isDouble: true,
    ctg: "telaviv",
    id: "Day_IsTrippin",
  },
  // End this post doubled for complite the TEL AVIV Carousel

  // These 2 posts doubled for complite the CULINARY Carousel
  {
    title: "L’HEURE DE LA SHAKSHUKA",
    // "sml_desc": "Susshuka Zeit",
    sml_desc: "",
    // "desc": "Lerne Sie, wie man das weltberühmte\n Shakshuka-Gericht zubereitet!",
    desc: "",
    img: "/PostCarousel/22.jpg",
    img_mob: "/PostCarousel/video_mob/22.jpg",
    side_img: "/PostCarousel/22.jpg",
    read_more: "Weiterlesen",
    link: "/Posts/index.php?post=22",
    ctg: "culinary",
    vidId: "n4kCnPXEX7g",
    isVid: true,
    forVidPage: true,
    isDouble: true,
    id: "Shakshuka",
  },
  {
    // "title": "A Foodie’s Paradise‘",
    title: "Paradis pour les gourmets",
    // "sml_desc": "Explorez l’impressionnante scène culinaire de Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/99.jpg",
    img_mob: "/PostCarousel/video_mob/99.jpg",
    side_img: "/PostCarousel/99.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=Simply_Delicious",
    ctg: "culinarytelaviv",
    vidId: "n4kCnPXEX7g",
    isVid: true,
    forVidPage: true,
    isDouble: true,
    id: "Simply_Delicious",
  },

  // End These 2 posts doubled for complite the CULINARY Carousel

  // These 3 posts doubled for complite the NORTH Carousel
  {
    title: "HAÏFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: false,
    forVidPage: true,
    isDouble: true,
    ctg: "north",
    id: "Haifa_1",
  },
  {
    title: "DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee1.jpg",
    side_img: "/PostCarousel/galilee1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee_1",
    css_class: "unic-post-galilee1",
    isVid: false,
    forVidPage: true,
    isDouble: true,
    ctg: "north",
    id: "Galilee_1",
  },
  {
    title: "CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea_2",
    css_class: "unic-post-caesarea2",
    isVid: false,
    forVidPage: true,
    isDouble: true,
    ctg: "north",
    id: "Caesarea_2",
  },
  // END These 3 posts doubled for complite the NORTH Carousel
];

export const TouristInfoPosts = [
  {
    title: "CE QU'IL FAUT EMPORTER",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/what-to-pack.jpg",
    side_img: "/PostCarousel/what-to-pack.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-what-to-pack",
    isVid: false,
    ctg: "TouristInfo",
    id: "What_To_Pack",
  },
  {
    title: "APPAREILS ÉLECTRIQUES",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/electrical-appliances.jpg",
    side_img: "/PostCarousel/electrical-appliances.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-electrical-appliances",
    isVid: false,
    ctg: "TouristInfo",
    id: "Electrical_Appliances",
  },
  {
    title: "LE CLIMAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/weather.jpg",
    side_img: "/PostCarousel/weather.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-weather",
    isVid: false,
    ctg: "TouristInfo",
    id: "Weather",
  },
  {
    title: "TRANSPORTS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/transportation.jpg",
    side_img: "/PostCarousel/transportation.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-transportation",
    isVid: false,
    ctg: "TouristInfo",
    id: "Transportation",
  },
  {
    title: "FAQ",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/faq.jpg",
    side_img: "/PostCarousel/faq.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-faq",
    isVid: false,
    ctg: "TouristInfo",
    id: "Frequently_Asked_Questions",
  },

  {
    title: "MONNAIE ISRAÉLIENNE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/israeli-currency.jpg",
    side_img: "/PostCarousel/israeli-currency.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-israeli-currency",
    isVid: false,
    ctg: "TouristInfo",
    id: "Israeli_Currency",
  },
  {
    title: "Immigration et douane",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/immigration-customs.jpg",
    side_img: "/PostCarousel/immigration-customs.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-immigration-customs",
    isVid: false,
    ctg: "TouristInfo",
    id: "Immigration_Customs",
  },
  {
    title: "PASSEPORTS ET VISA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Passports-visa.jpg",
    side_img: "/PostCarousel/Passports-visa.jpg",
    read_more: "LIRE LA SuITE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: false,
    ctg: "TouristInfo",
    id: "Passports_Visa",
  },

  {
    title: "UNE DESTINATION POUR TOUS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    side_img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: true,
    ctg: "TouristInfo",
    id: "Destination_For_All",
  },
];

export const Reminders = [
  // Tel Aviv
  {
    quote: "One of the world's 25 best cities for foodies",
    site: "Business Insider",
    img: "/References/1.jpg",
    ctg: "Tel Aviv",
  },

  // Jerusalem
  {
    quote: "TripAdvisor Traveler's Choice Award 2015",
    site: "TripAdvisor",
    img: "/References/9.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's leading party cities",
    site: "Telegraph",
    img: "/References/2.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the cities with most beautiful people",
    site: "Conde Nast",
    img: "/References/3.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the 20 must visit destinations in the world  TNS",
    site: "The National Student",
    img: "/References/10.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the best beach party spots on the planet",
    site: "USA Today",
    img: "/References/4.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top 10 beach cities",
    site: "National Geographic",
    img: "/References/5.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "3rd Of 6 Top world’s holiest sites",
    site: "National Geographic",
    img: "/References/11.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's top ten cities",
    site: "Lonely Planet",
    img: "/References/6.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top ten hedonistic city breaks ",
    site: "Lonely Planet",
    img: "/References/7.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote:
      "I just thought it was magical… It instantly turned into my favorite trip.",
    site: "TripAdvisor",
    img: "/References/12.jpg",
    ctg: "Jerusalem",
    job: "CEO, Stephen Kaufer about Jerusalem",
    cssClass: "make-it-smller",
  },

  {
    quote: "The World’s New Dining Hotspot",
    site: "Bloomberg.com",
    img: "/References/8.jpg",
    ctg: "Tel Aviv",
  },
];



// WEBPACK FOOTER //
// ./src/Data/Data.js